<template>
  <div
    v-if="x.totalResults"
    class="x-flex x-items-center x-justify-end x-gap-24 x-text-lead-75"
    :class="{ 'x-mb-8': !x.selectedFilters.length }"
    data-test="total-results"
  >
    <i18n-t
      class="x-text1 x-text1-lg x-flex-auto"
      keypath="totalResults.message"
      tag="span"
      scope="global"
      :plural="x.totalResults"
    >
      <template #totalResults>
        {{ x.totalResults }}
      </template>
      <template #query>
        <span class="x-title3">
          {{ x.spellcheckedQuery || query }}
        </span>
      </template>
    </i18n-t>

    <BaseIdModalOpen
      modal-id="right-aside"
      class="x-button-neutral x-button-outlined"
      data-test="toggle-facets-button"
    >
      <FiltersIcon class="x-icon-lg" />
      <span class="x-font-light x-capitalize">{{ $t('toggleAside.showAside') }}</span>
      <span
        v-if="x.selectedFilters.length"
        :class="{ 'x-badge-circle': x.selectedFilters.length <= 9 }"
        class="x-badge x-badge-auxiliary"
      >
        {{ x.selectedFilters.length }}
      </span>
    </BaseIdModalOpen>

    <SortSelector />
  </div>
</template>

<script setup lang="ts">
import { BaseIdModalOpen, FiltersIcon, use$x, useGetter } from '@empathyco/x-components'
import SortSelector from '../search/sort-selector.vue'

const x = use$x()
const { query } = useGetter('search')
</script>
